import React, { useMemo } from 'react'

import { IMarket } from 'interfaces'
import { APP_URL } from 'config/app'
import { API_HOST } from 'config/api'
import { Card } from 'components'
import { parseTpl } from 'utils/helpers'
import style from './MarketItem.module.css'

type MarketCategoryPropType = {
    category: IMarket
    url?: string
}

const MarketItem: React.FC<MarketCategoryPropType> = ({ category, url }) => {
    const categoryUrl = useMemo(getUrl, [category])
    const title = useMemo(getTitle, [category])
    const image = useMemo(getImage, [category])

    function getUrl() {
        if (url) {
            return url
        }
        return parseTpl(APP_URL.category, { ':id': category.id }, { prefix: '', suffix: '' })
    }

    function getTitle() {
        if (category.pluralName) {
            return category.pluralName
        }
        return category.name
    }

    function getImage() {
        return category?.image ? `${API_HOST}${category.image}` : ''
    }

    return (
        <Card.Item classes={style.item} url={categoryUrl}>
            <Card.Image src={image} backgroundColor={category.color} width={400} />
            <Card.Body classes={style.body} title={title} />
        </Card.Item>
    )
}

export default MarketItem
